import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

import { CONTACT_STEP, INFO_STEP } from "../helpers/constants";

export const AppStateContext = createContext({});

export function AppProvider({ children }) {
	const value = useState({
		currentZipCode: "",
		destinationZipCode: "",
		moveDate: null,
		moveSize: "",
		firstName: "",
		lastName: "",
		email: "",
		phoneNumber: "",
		// The current step of the wizard is tracked for analytics purposes
		step: INFO_STEP,
		// The submitted state is tracked for browser back button handling
		submittedStepStatus: {
			[INFO_STEP]: false,
			[CONTACT_STEP]: false,
		},
	});

	return (
		<AppStateContext.Provider value={value}>
			{children}
		</AppStateContext.Provider>
	);
}

export function useAppState() {
	const context = useContext(AppStateContext);
	if (!context) {
		throw new Error("useAppState must be used within the AppProvider");
	}

	return context;
}

AppProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
